export default "__VITE_ASSET__7a756edb__"